import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackScreenProps,
} from '@react-navigation/native-stack';
import {ProjectDetails} from './ProjectDetails';
import {RootNavigatorParams, Routes} from 'navigation/Routes';
import {UpdateProject} from './UpdateProject';
const ProjectRequireMentStack = createNativeStackNavigator();

export function ProjectRequirements({
  navigation,
}: NativeStackScreenProps<RootNavigatorParams>) {
  return (
    <ProjectRequireMentStack.Navigator screenOptions={{headerShown: false}}>
      <ProjectRequireMentStack.Screen
        name={Routes.PROJECT_DETAILS}
        component={ProjectDetails}
      />

      <ProjectRequireMentStack.Screen
        name={Routes.PROJECT_EDIT}
        component={UpdateProject}
      />
    </ProjectRequireMentStack.Navigator>
  );
}
